import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import { trackVirtualPageView } from './utils/tracking';

Vue.use(Router);

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

const updatePageTitleStatus = (title) => {
  const pageUpdateEl = document.getElementById('page-status-update-el');
  pageUpdateEl.textContent = '';
  pageUpdateEl.textContent = title;
};

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/personal-info',
      name: 'personalInfo',
      props: {
        next_route: 'vehicleInfo',
        button_label: 'Your Ride',
      },
      // route level code-splitting
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "signup" */ './views/SignUp.vue'),
      beforeEnter: (to, from, next) => {
        trackVirtualPageView('/personal-info');
        scrollToTop();
        next();
        document.title = 'Personal Info | Nitto Pit Crew';
        updatePageTitleStatus('Current page is Personal Info');
      },
    },
    {
      path: '/vehicle-info',
      name: 'vehicleInfo',
      props: {
        next_route: 'tireInfo',
        button_label: 'Your Tires',
      },
      component: () => import(/* webpackChunkName: "signup" */ './views/SignUp.vue'),
      beforeEnter: (to, from, next) => {
        trackVirtualPageView('/vehicle-info');
        scrollToTop();
        next();
        document.title = 'Vehicle Info | Nitto Pit Crew';
        updatePageTitleStatus('Current page is Vehicle Info');
      },
    },
    {
      path: '/tire-info',
      name: 'tireInfo',
      props: {
        next_route: 'gearInfo',
        button_label: 'Your Swag',
      },
      component: () => import(/* webpackChunkName: "signup" */ './views/SignUp.vue'),
      beforeEnter: (to, from, next) => {
        trackVirtualPageView('/tire-info');
        scrollToTop();
        next();
        document.title = 'Tire Info | Nitto Pit Crew';
        updatePageTitleStatus('Current page is Tire Info');
      },
    },
    {
      path: '/gear-info',
      name: 'gearInfo',
      props: {
        next_route: 'contactInfo',
        button_label: 'Your Shipping Address',
      },
      component: () => import(/* webpackChunkName: "signup" */ './views/SignUp.vue'),
      beforeEnter: (to, from, next) => {
        trackVirtualPageView('/gear-info');
        scrollToTop();
        next();
        document.title = 'Gear Info | Nitto Pit Crew';
        updatePageTitleStatus('Current page is Gear Info');
      },
    },
    {
      path: '/contact-info',
      name: 'contactInfo',
      props: {
        next_route: 'socialInfo',
        button_label: 'Your Socials',
      },
      component: () => import(/* webpackChunkName: "signup" */ './views/SignUp.vue'),
      beforeEnter: (to, from, next) => {
        trackVirtualPageView('/contact-info');
        scrollToTop();
        next();
        document.title = 'Contact Info | Nitto Pit Crew';
        updatePageTitleStatus('Current page is Contact Info');
      },
    },
    {
      path: '/social-info',
      name: 'socialInfo',
      props: {
        next_route: 'enthusiastInfo',
        button_label: 'Your Last Step',
      },
      component: () => import(/* webpackChunkName: "signup" */ './views/SignUp.vue'),
      beforeEnter: (to, from, next) => {
        trackVirtualPageView('/social-info');
        scrollToTop();
        next();
        document.title = 'Social Info | Nitto Pit Crew';
        updatePageTitleStatus('Current page is Social Info');
      },
    },
    {
      path: '/enthusiast-info',
      name: 'enthusiastInfo',
      props: {
        next_route: 'confirmation',
        button_label: 'Submit',
      },
      component: () => import(/* webpackChunkName: "signup" */ './views/SignUp.vue'),
      beforeEnter: (to, from, next) => {
        trackVirtualPageView('/enthusiast-info');
        scrollToTop();
        next();
        document.title = 'Enthusiast Info | Nitto Pit Crew';
        updatePageTitleStatus('Current page is Enthusiast Info');
      },
    },
    {
      path: '/confirmation',
      name: 'confirmation',
      props: {
        next_route: '',
        final_step: true,
      },
      component: () => import(/* webpackChunkName: "confirmation" */ './views/Confirmation.vue'),
      beforeEnter: (to, from, next) => {
        trackVirtualPageView('/confirmation');
        scrollToTop();
        next();
        document.title = 'Confirmation | Nitto Pit Crew';
        updatePageTitleStatus('Current page is Confirmation Info');
      },
    },
    {
      path: '/style-guide',
      name: 'styleGuide',
      component: () => import(/* webpackChunkName: "styleguide" */ './views/StyleGuide.vue'),
      beforeEnter: (to, from, next) => {
        scrollToTop();
        next();
      },
    },
  ],
});
